import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Challenge } from '../types';

interface ChallengeCardProps {
  challenge: Challenge;
}

const ChallengeCard: React.FC<ChallengeCardProps> = ({ challenge }) => {
  const navigate = useNavigate();
  const { id, title, description, category, difficulty } = challenge;
  
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Composition':
        return 'bg-blue-500';
      case 'Lighting':
        return 'bg-amber-500';
      case 'Technical':
        return 'bg-emerald-500';
      case 'Creative':
        return 'bg-purple-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getDifficultyStyles = (difficulty: string) => {
    switch (difficulty) {
      case 'Beginner':
        return {
          border: 'border-green-900/30',
          glow: 'group-hover:shadow-[0_0_15px_rgba(34,197,94,0.15)]',
          text: 'text-green-400'
        };
      case 'Intermediate':
        return {
          border: 'border-yellow-900/30',
          glow: 'group-hover:shadow-[0_0_15px_rgba(234,179,8,0.15)]',
          text: 'text-yellow-400'
        };
      case 'Advanced':
        return {
          border: 'border-red-900/30',
          glow: 'group-hover:shadow-[0_0_15px_rgba(239,68,68,0.15)]',
          text: 'text-red-400'
        };
      default:
        return {
          border: 'border-gray-700',
          glow: 'group-hover:shadow-md',
          text: 'text-gray-400'
        };
    }
  };

  const difficultyStyles = getDifficultyStyles(difficulty);

  return (
    <div 
      onClick={() => navigate(`/challenge/${id}`)}
      className={`group bg-[#1e1e1e] rounded-lg p-5 border-2 ${difficultyStyles.border} 
        transition-all duration-300 hover:border-opacity-50 hover:translate-y-[-2px] 
        ${difficultyStyles.glow} cursor-pointer`}
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center justify-between mb-3">
          <span className={`text-xs px-2 py-1 rounded ${getCategoryColor(category)} text-white font-medium`}>
            {category}
          </span>
          <span className={`text-xs font-medium ${difficultyStyles.text}`}>{difficulty}</span>
        </div>
        
        <h2 className="text-white text-lg font-medium mb-2">{title}</h2>
        
        <p className="text-gray-400 text-sm flex-grow line-clamp-3">{description}</p>
      </div>
    </div>
  );
};

export default ChallengeCard;